var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.324,
    height: 42.459,
    viewBox: "0 0 35.324 42.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M179,139.21h35.324v42.459H179Z",
    transform: "translate(-179 -139.21)",
    fill: "#404040"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "html",
    transform: "translate(-179 -139.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451",
    transform: "translate(179 139.21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M183.067,174.286v7.389H215.13V148.091l-8.875-8.875H183.067v22.971h-3.085v12.1l3.084,3.084v-3.084Zm23.85-31.867,5.01,5.009h-5.01Zm-22.523-1.876h21.2v8.212H213.8v31.594H184.394v-6.062H211.95v-12.1H184.394Zm-3.085,22.971h29.314v9.444H181.309Z",
    transform: "translate(-179.894 -139.215)",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(187.662 171.295)",
    fill: "#404040",
    fontSize: 8.5,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfTypeIcon);
export default __webpack_public_path__ + "static/media/pdfTypeIcon.972b08d195f3b9f5103a1feba7fcf8f1.svg";
export { ForwardRef as ReactComponent };